<fui-edit-fascia [disabled]="disabled || readonly" (focussed$)="focus()">
    <fui-fixtures>
        <fui-fixture>
            <fui-checkbox-dom [disabled]="disabled" [readonly]="readonly"
                              [focussed]="focussed" [hovered]="hovered" [valued]="valued">
                <input (blur)="onBlur($event)" [disabled]="disabled || readonly" (focus)="onFocus($event)" [id]="name"
                       #input [name]="name"
                       [(ngModel)]="value" [tabindex]="tabindex" type="checkbox">
            </fui-checkbox-dom>
        </fui-fixture>
        <fui-fixture>
            <fui-checkbox-label [disabled]="disabled || readonly" [focussed]="focussed" [hovered]="hovered"
                                [title]="label" [i18NParams]="labelI18NParams" [valued]="valued"></fui-checkbox-label>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
